
export default function handleResponse(response) {
    return response.data;
}